import { getErrorMessage, TOXPRINTS_URL } from '@/main'
import Axios from 'axios'

const state = {
  toxprintsResult: { chemicals: [], metrics: [] },
  toxprintsSelectedChemical: null,

  toxprintsLabels: [],
  toxprintsMetrics: [],
  toxprintsCategories: [],
  toxprintsProfiles: [],
  toxprintsDefaultProfile: null,
  toxprintsBuildDate: null,
}

const getters = {
  toxprintsResult: (state) => {
    return state.toxprintsResult
  },
  toxprintsSelectedChemical: (state) => {
    return state.toxprintsSelectedChemical
  },
  toxprintsLabels: (state) => {
    return state.toxprintsLabels
  },
  toxprintsMetrics: (state) => {
    return state.toxprintsMetrics
  },
  toxprintsCategories: (state) => {
    return state.toxprintsCategories
  },
  toxprintsProfiles: (state) => {
    return state.toxprintsProfiles
  },
  toxprintsDefaultProfile: (state) => {
    return state.toxprintsDefaultProfile
  },
}

const mutations = {
  setToxprintsResult: (state, payload) => {
    state.toxprintsResult = payload
  },
  resetToxprintsResult: (state) => {
    state.toxprintsResult = { chemicals: [], metrics: [] }
    state.toxprintsSelectedChemical = null
  },
  setToxprintsSelectedChemical: (state, payload) => {
    state.toxprintsSelectedChemical = payload
  },
  toxprintsLabels: (state, payload) => {
    state.toxprintsLabels = payload
  },
  toxprintsMetrics: (state, payload) => {
    state.toxprintsMetrics = payload
  },
  toxprintsCategories: (state, payload) => {
    state.toxprintsCategories = payload
  },
  toxprintsProfiles: (state, payload) => {
    state.toxprintsProfiles = payload
  },
  toxprintsDefaultProfile: (state, payload) => {
    state.toxprintsDefaultProfile = payload
  },
}

const actions = {
  calculateToxprints(context, payload) {
    return this._vm.$axios.post(`${TOXPRINTS_URL}/calculate`, payload).then((response) => {
      context.commit('setToxprintsResult', response.data)
    })
  },
}

export function prepareToxprintsMetadata(context) {
  Axios.get(`${TOXPRINTS_URL}/metadata`)
    .then((response) => {
      context.commit('toxprintsLabels', response.data.labels)
      context.commit('toxprintsMetrics', response.data.metrics)
      context.commit('toxprintsCategories', response.data.categories)
      context.commit('toxprintsProfiles', response.data.profiles)
      context.commit('toxprintsDefaultProfile', response.data.defaultProfile)
      context.commit('setFeatures', { toxprints: { category: 'module' } })
    })
    .catch((error) => {
      console.warn('TOXPRINTS module is not available: %o', getErrorMessage(error))
      context.commit('removeFeature', { toxprints: {} })
    })
}

export default {
  state,
  getters,
  mutations,
  actions,
}
